import React, { useEffect } from 'react';
import { Radio, Typography } from 'antd';
import {
    NO_LABELS_MODE_DEFAULT,
    NO_LABELS_MODE_GENERATE_WITH_AI,
    NO_LABELS_MODE_UNLABELED,
    noLabelsModeOptions,
} from '@/features/datasets/utils/hasLabelsHandling';

const { Text } = Typography;

/**
 * Follow-up radios when "Does your data contain labels?" is OFF:
 * Generate with AI (default) vs add unlabeled.
 *
 * Pure presentation — parent owns `value` / `onChange`.
 *
 * @param {Object} props
 * @param {'generate_with_ai'|'unlabeled'} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.taskType]
 * @param {Object} [props.style]
 */
const NoLabelsModeChoice = ({ value, onChange, taskType, style }) => {
    const options = noLabelsModeOptions(taskType);
    const allowed = options.map((o) => o.value);
    const selected = allowed.includes(value) ? value : NO_LABELS_MODE_DEFAULT;

    useEffect(() => {
        if (!allowed.includes(value)) {
            onChange(NO_LABELS_MODE_DEFAULT);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, taskType]);

    return (
        <div style={{ marginTop: 4, marginBottom: 16, ...style }}>
            <Text
                style={{
                    display: 'block',
                    fontWeight: 600,
                    color: '#222',
                    fontSize: 14,
                    marginBottom: 12,
                }}
            >
                How would you like to proceed?
            </Text>
            <Radio.Group
                value={selected}
                onChange={(e) => onChange(e.target.value)}
                style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}
            >
                {options.map((opt) => (
                    <div key={opt.value} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Radio value={opt.value} style={{ fontSize: 14, color: '#222' }}>
                            {opt.title}
                        </Radio>
                        <Text
                            style={{
                                paddingLeft: 24,
                                color: 'rgba(0, 0, 0, 0.45)',
                                fontSize: 12,
                                lineHeight: 'normal',
                            }}
                        >
                            {opt.description}
                        </Text>
                    </div>
                ))}
            </Radio.Group>
        </div>
    );
};

export {
    NO_LABELS_MODE_DEFAULT,
    NO_LABELS_MODE_GENERATE_WITH_AI,
    NO_LABELS_MODE_UNLABELED,
};
export default NoLabelsModeChoice;
